/**
 *  Enum representing possible car status values.
 */
export enum THGCarStatus {
    PRE_RESERVED = 'pre-reserved', // currently: AT 2024 only
    PRE_RESERVATION_DELETED = 'pre-reservation-deleted', // currently: AT 2024 only
    DATA_RECEIVED = 'data-received',
    UNDER_REVIEW = 'under-review',
    REG_SUBMITTED = 'reg-submitted',
    REG_DECLINED = 'reg-declined', // currently: AT only
    UBA_SUBMITTED = 'uba-submitted',
    CERT_RECEIVED = 'cert-received',
    CERT_DECLINED = 'cert-declined',
    INCOME_PAID_OUT = 'income-paid-out',
}
